import { IBaseModel } from '../system/BaseModel';

export enum ChatRole {
  User,
  Assistant,
}

export interface ChatMessage {
  userId?: string;
  role: ChatRole;
  content: string;
  timestamp: Date;
}

export interface ChatHistoryMessages extends IBaseModel {
  messages: ChatMessage[];
}

export interface ChatRequest {
  chatId: string;
  message: string;
}

export interface ChatResponse {
  reply: string;
  title?: string;
}

export interface ChatHistory extends IBaseModel {
  title: string;
  organisationId: string;
}
